const validateEmail = (email) => {
  // eslint-disable-next-line
  const regEx = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  return regEx.test(email.toLocaleLowerCase());
};

const validatePasswordStrength = (password) => {
  // 10 chars, one uppercase char, one lowercase char, one special char and one number
  // eslint-disable-next-line no-useless-escape
  const regEx = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\^$*.[\]{}()?"!@#%&\/\\,><':;|_~`]).{10,}/;
  return regEx.test(password);
};

export default {
  validateEmail,
  validatePasswordStrength,
};
